import { AppNotFoundItemError } from "../../errors/error-app";

export function getCurrentMediaObjectId(pathname: string): number {
    const locationIdMatch = pathname.toString().match(/\/media-gallery\/([0-9]+)/);
    if (locationIdMatch) {
        return parseInt(locationIdMatch[1]);
    }
    throw new AppNotFoundItemError("file");
}
